import { DAYS } from 'constants/automationConstants';
import { calculateDateTimeCylce, getFilteredContacts } from 'modules/settings/workflow_automation/helpers/automationCommonHelpers';
import { generateFullName } from 'utils/generateFullNameUtils';

/** --- generateFullAttendeesList - function generates full "Attendees" list including Primary and Billing Contacts--- **/
export const generateFullAssigneesList = (params = {}) => {
  const { setAssignToList = [], firmUsersList = [], getAllRequiredContactsList = () => {} } = params || {};

  let allAssignees = getAllRequiredContactsList(firmUsersList);
  allAssignees.reverse();
  setAssignToList(allAssignees);
};

export const generateAssigneeDetailsObjectArray = (params = {}) => {
  const { assignToList = [], assignToWatched: selectedAssignees = [] } = params || {};

  let assigneesDetailsArr = [];
  let allContactList = [];

  if (assignToList?.length > 0) {
    assignToList?.forEach((element) => {
      if (element?.items?.length) {
        allContactList.push(...element?.items);
      }
    });
  }

  if (selectedAssignees?.length && allContactList?.length) {
    selectedAssignees?.forEach((asg, idx) => {
      allContactList?.forEach((assignee, index) => {
        let condition = asg === assignee?.value;
        if (condition) {
          assigneesDetailsArr.push(assignee);
        }
      });
    });
  }

  return assigneesDetailsArr;
};

export const generatePayloadCompatibleFormattedAssigneesList = (params) => {
  const { assigneesArr = [], isBillingOrPrimary = false, isFirmUser = true, isUserGroup = false, isTeamMember } = params || {};
  let formatttedAssigneesArr = [];
  let filteredAssignees = [];

  filteredAssignees = getFilteredContacts({
    arrayToBeFiltered: assigneesArr,
    isBillingOrPrimary,
    isFirmUser,
    isUserGroup,
    isTeamMember,
  });

  formatttedAssigneesArr = filteredAssignees?.map((assignee, idx) => {
    if (assignee?.email) {
      // Firm users only
      const { label: fullName, contact_id, email, client_cognito_username, firm_user_id, access_level } = assignee || {};

      return {
        assignee_id: client_cognito_username || firm_user_id || contact_id,
        assignee_name: fullName,
        email,
        firm_user_id,
        access_level,
        cognito_username: client_cognito_username,
      };
    } else if (assignee?.group_id) {
      // User group items only
      const { label: groupName, pk, group_id, sk } = assignee || {};
      return {
        group_name: groupName,
        sk,
        group_id,
        pk,
      };
    } else if (assignee?.code && assignee?.code === 'TEAM_MEMBER_ROLE') {
      //Team member roles only
      return assignee?.value;
    }
    // primary and billing contacts only
    return assignee?.value;
  });
  return formatttedAssigneesArr;
};

export const calculateDueDateCycle = (dateCount = 0, datePeriod = DAYS) => {
  return calculateDateTimeCylce(dateCount, datePeriod);
};

export const getFilteredSubTasks = (subTasksArr = []) => {
  let filteredArr = [];
  if (subTasksArr?.length) {
    filteredArr = subTasksArr?.filter((item, idx) => item?.sub_task_description);
  }
  return filteredArr;
};

export const generatePayloadCompatibleTaskReminder = (reminderArr = []) => {
  let reminderValuesArr = [];

  if (reminderArr?.length > 0) {
    reminderValuesArr = reminderArr?.map((rem, idx) => rem?.value);
  }

  return reminderValuesArr;
};

const teamMembersRoleValuesList = ['lead_attorney', 'lead_associate', 'lead_paralegal', 'lead_case_manager'];

export const generateSubTaskPayload = (subTask, firmUsersList) => {
  return subTask?.map((item) => {
    return {
      ...item,
      ...item?.assign_to?.reduce(
        (acc, val) => {
          const { assign_to = [], contact_assignees = [], firm_user_assignees = [] } = acc || {};
          if (teamMembersRoleValuesList?.includes(val)) {
            firm_user_assignees.push(val);
          } else if (val === 'primary_contact' || val === 'billing_contact') {
            contact_assignees.push(val);
          } else {
            const user = firmUsersList?.find((v) => v?.client_cognito_username === val);
            assign_to.push({
              assignee_id: user?.client_cognito_username || user?.firm_user_id || user?.contact_id,
              assignee_name: generateFullName(user),
              email: user?.email,
              firm_user_id: user?.firm_user_id,
              access_level: user?.access_level,
              cognito_username: user?.client_cognito_username,
            });
          }
          return { assign_to, contact_assignees, firm_user_assignees };
        },
        { assign_to: [], contact_assignees: [], firm_user_assignees: [] }
      ),
    };
  });
};

export const generateSubTaskData = (subTasks = []) => {
  return subTasks?.map((val) => ({
    assign_to: [
      ...(val?.contact_assignees || []),
      ...(val?.firm_user_assignees || []),
      ...(val?.assign_to?.map((v) => v?.assignee_id) || []),
    ],
    sk: val?.sk,
    sub_task_description: val?.sub_task_description,
    sub_task_status: val?.sub_task_status,
  }));
};

export function getSubTaskFirmUserIds(data) {
  const firmUserIds = [];

  data.forEach((task) => {
    if (Array.isArray(task.assign_to)) {
      task.assign_to.forEach((assignee) => {
        if (assignee.cognito_username) {
          firmUserIds.push(assignee.cognito_username);
        }
      });
    }
  });

  return firmUserIds;
}
